const KEY = "recentClients"
const MAX = 5

export interface RecentClient {
  id: string
  displayName: string
  providerClientId: string
}

export function pushRecentClient(client: RecentClient): void {
  const existing = getRecentClients().filter((c) => c.id !== client.id)
  const updated = [client, ...existing].slice(0, MAX)
  sessionStorage.setItem(KEY, JSON.stringify(updated))
}

export function getRecentClients(): RecentClient[] {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) ?? "[]")
  } catch {
    return []
  }
}
